import { t } from '@lingui/core/macro';
import { TDateUnit } from 'lendingApi/applications.types';
import { getDurationInMonths } from 'utils/durationHelper';

type TLoanDurationRangeDE =
  | '1 - 12 months'
  | '13 - 24 months'
  | '25 - 60 months';

export const getLoanDurationRange = (
  duration?: { amount: number; unit: TDateUnit } | null,
): TLoanDurationRangeDE | undefined => {
  if (!duration) {
    return;
  }

  const durationInMonths = getDurationInMonths(duration);

  switch (durationInMonths) {
    case 12:
      return t`1 - 12 months` as TLoanDurationRangeDE;
    case 24:
      return t`13 - 24 months` as TLoanDurationRangeDE;
    case 60:
      return t`25 - 60 months` as TLoanDurationRangeDE;
  }
};
